import { Instrument } from 'types/Instrument';

export const SYMBOL = {
  'NIFTY 50': 'NIFTY',
  'NIFTY BANK': 'BANKNIFTY',
  'NIFTY FIN SERVICE': 'FINNIFTY',
};

export const LIVEDATASYMBOL = {
  'NIFTY 50': 'NIFTY_SPACE_50',
  'NIFTY BANK': 'NIFTY_SPACE_BANK',
  'NIFTY FIN SERVICE': 'NIFTY_SPACE_FIN_SPACE_SERVICE',
};

export const SUBSCRIPTIONSYMBOL = {
  'NIFTY 50': 'NIFTY_SYMBOL',
  'NIFTY BANK': 'BANK_NIFTY_SYMBOL',
  'NIFTY FIN SERVICE': 'FIN_NIFTY_SYMBOL',
};

// Utility function to find instruments by symbol and other criteria
export const findInstrumentsBySymbol = (
  instruments: Instrument[],
  symbol: string,
  strike: number,
  contractType: string,
  expiry: string
): Instrument[] => {
  const mappedSymbol = SYMBOL[symbol as keyof typeof SYMBOL];
  
  if (!mappedSymbol) {
    return [];
  }

  // Try multiple filtering strategies
  let filteredInstruments = instruments.filter(instrument => 
    instrument.name === mappedSymbol &&
    instrument.strike_price === strike &&
    instrument.instrument_type === contractType &&
    instrument.expiry === expiry &&
    instrument.exchange_ids === 'NFO'
  );

  // If no exact match, try trading_symbol
  if (filteredInstruments.length === 0) {
    filteredInstruments = instruments.filter(instrument => 
      instrument.trading_symbol.includes(mappedSymbol) &&
      instrument.strike_price === strike &&
      instrument.instrument_type === contractType &&
      instrument.expiry === expiry &&
      instrument.exchange_ids === 'NFO'
    );
  }

  // If still no match, try case-insensitive matching
  if (filteredInstruments.length === 0) {
    filteredInstruments = instruments.filter(instrument => 
      (instrument.name.toLowerCase() === mappedSymbol.toLowerCase() ||
       instrument.trading_symbol.toLowerCase().includes(mappedSymbol.toLowerCase())) &&
      instrument.strike_price === strike &&
      instrument.instrument_type === contractType &&
      instrument.expiry === expiry &&
      instrument.exchange_ids === 'NFO'
    );
  }

  return filteredInstruments;
};
